import * as types from "./mutation_types";

export default {
  [types.TRANSPORT_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
    });
  },

  [types.TRANSPORT_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.TRANSPORT_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.TRANSPORT_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
